import type {
  Command,
  CommandPlugin,
} from '@nora-monorepo/ui-shared';
import {
  i18n as i18nSetup,
  useDarkModeStore,
} from '@nora-monorepo/ui-shared';

import { useConversationStore } from '#nora-chat-ui/stores/conversation/conversation-store';

const { t } = i18nSetup.global;

export function ConversationCommandPlugin(
  openCreateConversationModal: () => void,
): CommandPlugin {
  const id = 'conversationPlugin';

  async function getCommands(): Promise<Command[]> {
    const pluginCommands: Command[] = [];

    pluginCommands.push(
      {
        id: 'setDarkMode',
        title: t('commands.plugins.settings.setDarkMode'),
        action: () => {
          const darkModeStore = useDarkModeStore();
          darkModeStore.setDarkMode('dark');
        },
      },
      {
        id: 'setLightMode',
        title: t('commands.plugins.settings.setLightMode'),
        action: () => {
          const darkModeStore = useDarkModeStore();
          darkModeStore.setDarkMode('light');
        },
      },
      {
        id: 'setSystemMode',
        title: t('commands.plugins.settings.setSystemMode'),
        action: () => {
          const darkModeStore = useDarkModeStore();
          darkModeStore.setDarkMode('system');
        },
      },
    );

    pluginCommands.push({
      id: 'createConversation',
      title: t('commands.plugins.conversations.createConversationTitle'),
      description: t(
        'commands.plugins.conversations.createConversationDescription',
      ),
      keywords: t('commands.plugins.conversations.createConversationKeywords'),
      action: () => {
        openCreateConversationModal();
      },
    });

    const conversationStore = useConversationStore();
    if (conversationStore.conversations) {
      for (const conversation of conversationStore.conversations) {
        const conversationData = conversation.conversationListResult;
        const conversationId = conversationData.id;
        if (!conversationId) {
          continue;
        }
        const converationTitle
          = conversationStore.getConversationTitle(conversationId);
        pluginCommands.push({
          id: `openConversation-${conversationId}`,
          title: t('commands.plugins.conversations.openConversation', [
            converationTitle,
          ]),
          description: `${conversation.conversationListResult?.newestMessage?.message ?? ''}`,
          action: () => {
            conversationStore.setCurrentConversation(conversationData);
          },
        });
      }
    }

    return pluginCommands;
  }

  return {
    id,
    getCommands,
  };
}
